import {createStore} from 'vuex'

const store = createStore({
	state(){
		return {
			mainMenu:{},
			activeMenuElementId:0,
			formerActiveMenuId:0,
			formerActiveMenuHasSub:false,
			activePage:0
		}
	},
	mutations:{
		addMenuItems(state,payload){
			state.mainMenu = payload;
		},
		setMainMenuElementActiveVersionZero(state,payload){
			if (payload.id !== state.activeMenuElementId){
				state.formerActiveMenuId = state.activeMenuElementId;
				state.formerActiveMenuHasSub = false;
				state.activeMenuElementId = payload.id;

				for(let i=0;i<state.mainMenu.length;i++){
					const menuItem = state.mainMenu[i];
					if (menuItem.id === payload.id){

						menuItem.active = true
						menuItem.show = true

					} else {
						menuItem.active = false;
					}
					if (menuItem.id === state.formerActiveMenuId){
						if (menuItem.hasSub){
							state.formerActiveMenuHasSub = true;
						}
					}
				}
			}
		},
		setMainMenuElementActive(state,payload){

			if (payload.id !== state.activeMenuElementId){
				state.formerActiveMenuId = state.activeMenuElementId;
				state.formerActiveMenuHasSub = false;
				state.activeMenuElementId = payload.id;

				for(let i=0;i<state.mainMenu.length;i++){
					const menuItem = state.mainMenu[i];
					let subItemIsCurrent = false;
					if (menuItem.id === payload.id){

						menuItem.active = true
						menuItem.show = true
						//show content of first sub menu item
						if (menuItem.hasSub){
							for (let x=0;x<menuItem.subMenu.length;x++){
								const subMenuItem = menuItem.subMenu[x];
								subMenuItem.show = false;
								if (subMenuItem.current){
									subMenuItem.show = true;
									subItemIsCurrent=true;
								}
							}
						}
					} else {
						menuItem.active = false;
					}
					if (menuItem.id === state.formerActiveMenuId){
						if (menuItem.hasSub){
							state.formerActiveMenuHasSub = true;
						}
					}

					if (subItemIsCurrent){
						menuItem.show=false;
					}

				}
			}

		},
		hideActiveSubMenu(state){

			for(let i=0;i<state.mainMenu.length;i++){
				const menuItem = state.mainMenu[i];
				if (menuItem.id === state.activeMenuElementId){
					menuItem.active = !menuItem.active
					state.activeMenuElementId = 0;
					//show content of first sub menu item, hide others
					if (menuItem.hasSub){
						for (let x=0;x<menuItem.subMenu.length;x++){
							const subMenuItem = menuItem.subMenu[x];
							subMenuItem.show = false;
						}
					}

					break;
				}
			}
		},
		activePage(state,payload){
			state.activePage = payload;
		},

		showSubMenuContent(state,payload){

			for (let i=0;i<state.mainMenu.length;i++){
				const mainMenu = state.mainMenu[i];
				mainMenu.show=false;
				if (mainMenu.id === state.activeMenuElementId){
					for (let x=0;x<mainMenu.subMenu.length;x++){
						const subMenuItem = mainMenu.subMenu[x];
						subMenuItem.show = subMenuItem.id === payload.id;
					}
					break;
				}
			}
		},
		showMainMenuContent(state){

			for (let i=0;i<state.mainMenu.length;i++){
				const mainMenu = state.mainMenu[i];
				mainMenu.show=false;
				if (mainMenu.id === state.activeMenuElementId){
					mainMenu.show=true;
					for (let x=0;x<mainMenu.subMenu.length;x++){
						const subMenuItem = mainMenu.subMenu[x];
						subMenuItem.show = false;
					}
				}
			}
		}
	},
	getters:{
		mainMenu(state){
			return state.mainMenu;
		},
		positionLeft(state){
			return state.positionLeft;
		},
		activePage(state){
			return state.activePage;
		},
		hasSub(state){
			return state.formerActiveMenuHasSub;
		},
		activeMenuElementId(state){
			return state.activeMenuElementId;
		},
	},
	actions:{
		/**
		 * Check if a main menu point has a subMenu
		 * @return {boolean}
		 * @param context
		 * @param payload
		 */
		menuHasSub(context,payload){

			let hasSub = false;
			for(let i=0;i<this.state.mainMenu.length;i++){
				const menuItem = this.state.mainMenu[i];
				if (
					menuItem.id === payload.id &&
					menuItem.hasSub
				){
					hasSub = true;
					break;
				}
			}
			return hasSub;
		},
		loadMenuItems(context) {

			const data = JSON.parse(document.querySelector('#jsonMenu').innerHTML);
			console.log('menu data',data);
			for (let i=0;i<data.length;i++){
				const element = data[i];
				element.hasActiveSub=false;
				let activeSubElement = false;
				//check if subelement exist and has status active
				if (element.hasSub){
					for (let x=0;x<element.subMenu.length;x++){
						const subElement = element.subMenu[x];
						if (subElement.current){
							activeSubElement = true;
							break;
						}
					}
				}
				//set current main navigation element as current because one of its sub elements has status current
				if (activeSubElement){
					element.current = true;
				}
			}


			context.commit('addMenuItems',data);
			// // let  currentUrl = window.location.protocol +'//' + window.location.hostname;
			// // if (window.location.pathname !== '/'){
			// // 	currentUrl+='/'+ window.location.pathname;
			// // }
			// // if (process.env.NODE_ENV==='development'){
			// // 	currentUrl = '/fileadmin/json/menu.json'
			// // } else {
			// // 	//add type information to url
			// // 	currentUrl +='/menu';
			// // }
			// //
			// //
			// //
			// // fetch(currentUrl)
			// // 	.then((response)=>{
			// // 		if (response.ok) {
			// // 			return response.json();
			// // 		}
			// // 	})
			// // 	.then((data)=>{
			// 		for (let i=0;i<data.length;i++){
			// 			const element = data[i];
			// 			let activeSubElement = false;
			// 			//check if subelement exist and has status active
			// 			if (element.hasSub){
			// 				for (let x=0;x<element.subMenu.length;x++){
			// 					const subElement = element.subMenu[x];
			// 					if (subElement.current){
			// 						activeSubElement = true;
			// 						break;
			// 					}
			// 				}
			// 			}
			// 			//set current main navigation element as current because one of its sub elements has status current
			// 			if (activeSubElement){
			// 				element.current = true;
			// 			}
			// 		}
			// //
			// // 		context.commit('addMenuItems',data);
			// // 	}
			// // );

		}
	}
});



export default store;
